export default function getDatePartValue(dateParts: any, key: string): string {
  const datePart = dateParts.find((p: any) => p.type.toUpperCase() === key.toUpperCase());
  if (datePart) return datePart.value;

  return '';
}
